import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Moment from 'moment';

import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import { CurrentTheme, MagstimColor } from "common";

class MagstimDateRangePicker extends React.Component {

    constructor() {
		super();

		this.state = {
            startDateFromProps: undefined,
            startDate:undefined,
            endDateFromProps: undefined,
            endDate:undefined,
		};
    }

    onChangeStartDate = (e) =>{
        const newDate = Moment(e.target.value, 'YYYY-MM-DD');
        this.setState({startDate:newDate}, () => this.fireOnChangeDateRange() );
    }

    onChangeEndDate = (e) =>{
        const newDate = Moment(e.target.value, 'YYYY-MM-DD');
        this.setState({endDate:newDate}, () => this.fireOnChangeDateRange() );
    }

    fireOnChangeDateRange = () =>{
        if(this.props.onChangeDateRange){
            this.props.onChangeDateRange(this.state.startDate.toDate(), this.state.endDate.toDate());
        }
    }

    static getDerivedStateFromProps(props, state) {

        // If the props value has changed - update our state
        if(state.startDateFromProps !== undefined){
            if(state.startDateFromProps.format('YYYY-MM-DD') !== props.startDate.format('YYYY-MM-DD')){
                state.startDate = props.startDate;
                state.startDateFromProps = props.startDate;
            }
        }else{
            // Not set
            state.startDate = props.startDate;
            state.startDateFromProps = props.startDate;
        }

        if(state.endDateFromProps !== undefined){
            if(state.endDateFromProps.format('YYYY-MM-DD') !== props.endDate.format('YYYY-MM-DD')){
                state.endDate = props.endDate;
                state.endDateFromProps = props.endDate;
            }
        }else{
            // Not set
            state.endDate = props.endDate;
            state.endDateFromProps = props.endDate;
        }

        return state;
    }

    render() {

        const startDateValue = this.state.startDate.format('YYYY-MM-DD');
        const endDateValue = this.state.endDate.format('YYYY-MM-DD');

        return (
            <Wrapper>
                <InputGroup size={CurrentTheme().ControlSize}>
                    <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                        <InputGroupText>Start</InputGroupText>
                    </InputGroupAddon>
                    <Input type="date" value={startDateValue} max={endDateValue}  onChange={this.onChangeStartDate} onKeyDown={(e) => e.preventDefault()}/>
                    <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                        <InputGroupText>End</InputGroupText>
                    </InputGroupAddon>
                    <Input type="date" value={endDateValue} min={startDateValue}  onChange={this.onChangeEndDate} onKeyDown={(e) => e.preventDefault()}/>
                </InputGroup>
            </Wrapper>
        );
    }
}

MagstimDateRangePicker.propTypes = {
    startDate: PropTypes.objectOf(Moment),
    endDate: PropTypes.objectOf(Moment),
    onChangeDateRange:PropTypes.func
};

MagstimDateRangePicker.defaultProps = {
    startDate:Moment().subtract(1, "days"),
    endDate:Moment(),
    onChangeDateRange:undefined
};

const Wrapper = styled.div`

.input-group-text {
    font-size: ${ CurrentTheme().MagstimNavBarFontSize};
    font-weight: normal;
    color:${ MagstimColor.MagstimGroupHeaderText };
    background-color:  ${ MagstimColor.MagstimCardHeaderBackground };
    border: 0px;
}

.form-control{
    border: 0px;
}
   
`;


export default MagstimDateRangePicker;